import { DEPARTMENT_FETCHING, DEPARTMENT_FAILED, DEPARTMENT_SUCCESS } from "./types";

import DepartmentService from "../services/department.service";

export const getDepartment = (query) => async (dispatch) => {
  try {
    dispatch({
      type: DEPARTMENT_FETCHING,
    });
    const res = await DepartmentService.getDepartment(query);
    if (res) {
      dispatch({
        type: DEPARTMENT_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: DEPARTMENT_FAILED,
    });
    console.log(err);
  }
};

export const getDepartmentByIdCompany = (idCompany) => async (dispatch) => {
  try {
    dispatch({
      type: DEPARTMENT_FETCHING,
    });
    const res = await DepartmentService.getDepartmentByIdCompany(idCompany);
    if (res) {
      dispatch({
        type: DEPARTMENT_SUCCESS,
        payload: res.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEPARTMENT_FAILED,
    });
  }
};

export const getAllDepartmentVendorEmployees = (idCompany) => async (dispatch) => {
  try {
    dispatch({
      type: DEPARTMENT_FETCHING,
    });
    const res = await DepartmentService.getAllDepartmentVendorEmployees(idCompany);
    if (res) {
      dispatch({
        type: DEPARTMENT_SUCCESS,
        payload: res.data,
      });
    }
  } catch (error) {
    dispatch({
      type: DEPARTMENT_FAILED,
    });
  }
};
